/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function toCents(value?: string): number | undefined {
    if (!value) {
        return undefined;
    }

    const normalized = value.replace(/\./g, '').replace(',', '.');
    const parsed = Number.parseFloat(normalized);

    if (Number.isNaN(parsed)) {
        return undefined;
    }

    return Math.round(parsed * 100);
}

/**
 *
 *
 *
 *
 *
 */
export function parseGermanNumber(value?: string): number | undefined {
    if (!value) {
        return undefined;
    }

    const parsed = Number(value.replace(/\./g, '').replace(',', '.'));

    return Number.isNaN(parsed) ? undefined : parsed;
}
